import palette from '@lib/core/src/theme/palette';
import { Button, Stack, styled, TextareaAutosize, Typography } from '@mui/material';

export const Container = styled(Stack)(() => ({
  width: '300px',
  height: 'calc(100% / 3)',
  padding: '16px',
  gap: '16px',
  borderRadius: '16px',
  border: `1px solid ${palette.grey[1200]}`,
  background: palette.white
}));

export const AddEditButton = styled(Button)(() => ({
  width: '47px',
  height: '32px',
  backgroundColor: palette.grey[100],
  borderRadius: '16px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  textTransform: 'none',
  textDecoration: 'none',
  color: palette.black,
  '&:hover': {
    backgroundColor: palette.grey[200]
  }
}));

export const HeaderRow = styled(Stack)(() => ({
  justifyContent: 'space-between',
  flexDirection: 'row',
  alignItems: 'center'
}));

export const FocusIconWrapper = styled(Stack)(() => ({
  width: '40px',
  height: '40px',
  borderRadius: '8px',
  backgroundColor: '#FCF3F1',
  alignItems: 'center',
  justifyContent: 'center'
}));

export const Title = styled(Typography)(() => ({
  fontSize: '13px',
  fontWeight: 600,
  color: palette.black
}));

export const TextInput = styled(TextareaAutosize)({
  backgroundColor: 'transparent',
  width: '100%',
  resize: 'none',
  padding: '12px 12px 0',
  fontSize: '16px',
  fontFamily: 'inherit',
  lineHeight: 1.5,
  borderRadius: '8px',
  border: 'unset',
  '&:focus': {
    outline: 'unset',
    outlineOffset: '2px'
  },
  maxHeight: '96px',
  overflowY: 'auto'
});
